import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const MyCalendar = ({ startDate, setStartDate, style = {}, label, monthOnly }) => {

    return (<div>
        <label style={{ display: 'flex', marginTop: '15px', marginBottom: '-5px', fontSize: '15px', color: '#000', ...style, fontWeight: '700' }}>{label || ''}</label>
        <DatePicker showTimeSelect={!monthOnly} selected={startDate} dateFormat={monthOnly ? 'MMM/yyyy' : 'dd/MM/yyyy hh:mm a'} onChange={(date) => setStartDate(date)} />
    </div>);
}

export default MyCalendar